var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV2RevampedCreateRoomCloseX(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 37.0614,
    height: 37.0606,
    viewBox: "0 0 37.0614 37.0606",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.40204 37.0604C1.78737 37.0604 1.17225 36.8252 0.704471 36.357C-0.234697 35.4183 -0.234697 33.9005 0.704471 32.9618L32.9619 0.704038C33.9006 -0.234679 35.4183 -0.234679 36.3571 0.704038C37.2961 1.64276 37.2961 3.16046 36.3571 4.09918L4.09961 36.357C3.87707 36.5804 3.6125 36.7577 3.32115 36.8784C3.02979 36.9991 2.71742 37.061 2.40204 37.0604Z",
    fill: "url(#paint0_linear_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.6595 37.0604C34.0448 37.0604 33.4302 36.8252 32.9619 36.357L0.704471 4.09918C-0.234697 3.16046 -0.234697 1.64264 0.704471 0.704038C1.64319 -0.234679 3.16044 -0.234679 4.09961 0.704038L36.3571 32.9618C37.2961 33.9005 37.2961 35.4184 36.3571 36.357C35.8888 36.8275 35.2742 37.0604 34.6595 37.0604Z",
    fill: "url(#paint1_linear_0_4)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 14.7296,
    y1: 37.0605,
    x2: 14.7296,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A04D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_4",
    x1: 14.7296,
    y1: 37.0604,
    x2: 14.7296,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A04D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2RevampedCreateRoomCloseX);
export default __webpack_public_path__ + "static/media/v2_revamped_create_room_close_x.e27600301bbee529d11ecde4accc1860.svg";
export { ForwardRef as ReactComponent };